import PropTypes from "prop-types";
import React, { createContext, useContext, useEffect, useState } from "react";

import { isResponseOk, useFetch } from "@swa-ui/fetch";

import { ChaseContext } from "../ChaseProvider";
import { getChaseStorage } from "../chaseStorage";

const CHASE_SESSION_ENDPOINT = "/api/chase/v2/chase/feature/chase-session";

export const ChaseInstantCreditContext = createContext(null);
export const ChaseInstantCreditProvider = ({ children }) => {
  const { post, response } = useFetch();
  const [instantCreditData, setInstantCreditData] = useState(null);
  const { updateChaseInstantCreditDetails } = useContext(ChaseContext) ?? {};

  useEffect(() => {
    const chaseStorage = getChaseStorage();
    const chaseSessionId = chaseStorage?.value?.chaseSessionId;

    if (chaseSessionId && !instantCreditData) {
      fetchInstantCreditDetails(chaseSessionId);
    }
  }, []);

  useEffect(() => {
    const chaseReturnUrl = window.location.href;

    if (updateChaseInstantCreditDetails) {
      updateChaseInstantCreditDetails({ returnUrl: chaseReturnUrl });
    }
  }, []);

  const fetchInstantCreditDetails = async (chaseSessionId) => {
    if (!chaseSessionId) return null;

    await post(CHASE_SESSION_ENDPOINT, { chaseSessionId });

    if (isResponseOk(response)) {
      const instantCreditResponse = response.data;

      setInstantCreditData(instantCreditResponse.data);

      return instantCreditResponse?.data;
    }

    return null;
  };

  return (
    <ChaseInstantCreditContext.Provider value={getContextValue()}>
      {children}
    </ChaseInstantCreditContext.Provider>
  );

  function getContextValue() {
    return {
      instantCreditData,
    };
  }
};
ChaseInstantCreditProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
ChaseInstantCreditContext.displayName = "ChaseInstantCreditContext";
